export const NO_LOGIN_PATH = {
  LOGIN: '/login',
  FORGET_PWD: '/forgetPassword/:uuid',
} as const;

export const MENU_PATH = {
  USER_LIST: '/user',
  MACHINE_LIST: '/device',
  DEVICE_MODEL_LIST: '/device_model',
  ANDROID_OTA_LIST: '/device_ota',
  LINUX_OTA_LIST: '/linux_device_ota',
  SITE_LIST: '/site',
  DASHBOARD: '/dashboard',
} as const;

export type IMenuPath = Array<keyof typeof MENU_PATH>;

export const MAIN_PATH = {
  ...MENU_PATH,
  USER_PROFILE: '/profile',
  EDIT_DEVICE_MODEL: '/device_model/:deviceModelId',
  DEVICE_BSP_OTA: '/device_ota/bsp',
  LINUX_BSP_OTA: '/linux_device_ota/bsp',
  ECB_OTA: '/device_ota/ecb',
  LINUX_ECB_OTA: '/linux_device_ota/ecb',
  VBB_OTA: '/device_ota/vbb',
  LINUX_VBB_OTA: '/linux_device_ota/vbb',
} as const;

export default {
  ...NO_LOGIN_PATH,
  MAIN: '/',
  ...MAIN_PATH,
};
